import { curriculumAuthHeader, handleResponse, handleError } from '../helper';
import CurriculumAPIHelper from "../common/CurriculumApiHelper";
import APIURLConstants from "../common/ApiURLConstants";

export const CurriculumDataService = {
    getAllCurriculums,
    getPublicCurriculums,
    insertCurriculumBasic,
    getCurriculumById,
    updateCurriculumBasicDetails,
    updateCurriculumSectionDetails,
    updateCurriculumStatus,
    validateAnswers,
    updateSectionsSortOrder,
    updateCurriculumStartTime,
    updateCurriculumActiveStatus,
    assignCurriculumToUser,
    searchUsersToAssignCurriculum,
    updateCurriculumAccess,
    getCurriculumUserResponse,
    getMyCurriculums,
    updateSectionStartEndTime,
    getMyCurriculumsScores,
    updateCurriculumEndTime,
    updateQuizQuestionStartEndTime,
    getDashboardData,
    getPublicCurriculumById,
    validatePublicAnswers,
    getCurriculumUserFirstResponse,
    updateCurriculumCompletionStatus
};

function getAllCurriculums(payload) {
    return CurriculumAPIHelper.post(APIURLConstants.GET_ALL_CURRICULUMS, payload, curriculumAuthHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getPublicCurriculums(payload) {
    return CurriculumAPIHelper.post(APIURLConstants.GET_PUBLIC_CURRICULUMS, payload, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function insertCurriculumBasic(payload) {
    return CurriculumAPIHelper.post(APIURLConstants.INSERT_CURRICULUM, payload, curriculumAuthHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}


function getCurriculumById(data) {
    return CurriculumAPIHelper.post(APIURLConstants.GET_CURRICULUM_BYID, data, curriculumAuthHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function updateCurriculumBasicDetails(payload) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_CURRICULUM, payload, curriculumAuthHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function updateCurriculumSectionDetails(payload,type) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_CURRICULUM_SECTION_DETAILS, payload, curriculumAuthHeader(type))
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function updateCurriculumStatus(payload) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_CURRICULUM_STATUS, payload, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function validateAnswers(data) {
    return CurriculumAPIHelper.post(APIURLConstants.VALIDATE_ANSWER, data, curriculumAuthHeader())
        .then(data => {
            return {data:data.data, message:data.message};
        }).catch(handleError);
}

function validatePublicAnswers(data) {
    return CurriculumAPIHelper.post(APIURLConstants.VALIDATE_ANSWER_PUBLIC, data, curriculumAuthHeader())
        .then(data => {
            return {data:data.data, message:data.message};
        }).catch(handleError);
}

function updateSectionsSortOrder(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_CURRICULUM_SORT_ORDER, data, curriculumAuthHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function updateCurriculumStartTime(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_CURRICULUM_START_TIME, data, curriculumAuthHeader())
        .then(data => {
            return {data:data.data, message:data.message};
        }).catch(handleError);
}

function updateCurriculumActiveStatus(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_CURRICULUM_ACTIVE_STATUS, data, curriculumAuthHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function assignCurriculumToUser(data) {
    return CurriculumAPIHelper.post(APIURLConstants.ASSIGN_CURRICULUM_TO_USER, data, curriculumAuthHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function searchUsersToAssignCurriculum(data) {
    return CurriculumAPIHelper.post(APIURLConstants.SEARCH_USERS_TO_ASSIGN_CURRICULUM, data, curriculumAuthHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function updateCurriculumAccess(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_CURRICULUM_ACCESS, data, curriculumAuthHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getCurriculumUserResponse(id) {
    return CurriculumAPIHelper.get(APIURLConstants.CURRICULUM_GET_USER_RESPONSE(id), curriculumAuthHeader())
        .then(data => {
            return data.data; // Return the relevant data
        }).catch(handleError); // Handle errors
}

function getCurriculumUserFirstResponse(data) {
    return CurriculumAPIHelper.post(APIURLConstants.CURRICULUM_GET_USER_FIRST_RESPONSE, data, curriculumAuthHeader())
        .then(data => {
            return data.data; // Return the relevant data
        }).catch(handleError); // Handle errors
}

function getMyCurriculums(payload) {
    return CurriculumAPIHelper.post(APIURLConstants.GET_MY_ASSIGNED_CURRICULUMS, payload, curriculumAuthHeader())
        .then(data => {
            return data.data; // Return the relevant data
        }).catch(handleError); // Handle errors
}

function updateSectionStartEndTime(payload) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_SECTION_START_END_TIME, payload, curriculumAuthHeader())
        .then(data => {
            return {data:data.data, message:data.message}; // Return the relevant data
        }).catch(handleError); // Handle errors
}


function getMyCurriculumsScores(payload) {
    return CurriculumAPIHelper.post(APIURLConstants.GET_MY_CURRICULUMS_SCORE, payload, curriculumAuthHeader())
        .then(data => {
            return data.data; // Return the relevant data
        }).catch(handleError); // Handle errors
}


function updateCurriculumEndTime(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_CURRICULUM_END_TIME, data, curriculumAuthHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}


function updateQuizQuestionStartEndTime(payload) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_QUIZ_START_END_TIME, payload, curriculumAuthHeader())
        .then(data => {
            return {data: data.data, message: data.message}; // Return the relevant data
        }).catch(handleError); // Handle errors
}


function getDashboardData(fromDate, toDate) {
    const payload = {};
    if (fromDate) payload.fromDate = fromDate;
    if (toDate) payload.toDate = toDate;
    return CurriculumAPIHelper.post(APIURLConstants.CURRICULUM_GET_DASHBAORD_WIDGET_DATA, payload, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function getPublicCurriculumById(id) {
    return CurriculumAPIHelper.get(APIURLConstants.GET_PUBLIC_CURRICULUM_BYID(id), curriculumAuthHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function updateCurriculumCompletionStatus(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_CURRICULUM_COMPLETION_STATUS, data, curriculumAuthHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}